import {styled} from '@mui/material';

export const CustomStepperStyled = styled('div')<{ownerState: {active?: boolean}}>(({theme}) => ({
	display: 'flex',
	width: 24,
	height: 24,
	paddingTop: '4px',
	'& .CustomStepperIcon-completedIcon': {
		color: theme.colors.brand.primary.white,
		backgroundColor: theme.colors.brand.primary.blue,
		zIndex: 1,
		fontSize: 18,
		width: 24,
		height: 24,
		borderRadius: '50%',
	},
	'& .CustomStepperIcon-circle': {
		width: 24,
		height: 24,
		borderRadius: '50%',
		border: `2px solid ${theme.colors.gray['30Percent']}`,
	},
}));
